import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export const PrivacyPage = () => {
  return (
    <div data-testid="privacy-page">
      {/* Hero Section */}
      <section className="hero-section py-16 md:py-20">
        <div className="container-law">
          <div className="breadcrumb text-white/60 mb-6">
            <Link to="/" className="hover:text-white">Home</Link>
            <ChevronRight className="w-4 h-4" />
            <span>Privacy Policy</span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl text-white">Privacy Policy</h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20">
        <div className="container-law">
          <div className="max-w-3xl">
            <p className="text-gray-500 mb-8">Effective Date: February 2026</p>

            {/* Section 1 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">1. Overview</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Kattorney.com is operated by Erlichman Law PLLC. This Privacy Policy explains how we collect, use, and protect information obtained through this website.
              </p>
              <p className="text-gray-600 leading-relaxed">
                This website is intended for informational purposes only and is not designed to collect sensitive personal data.
              </p>
            </div>

            {/* Section 2 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">2. Information We Collect</h2>
              
              <h3 className="font-medium text-navy mb-3">Information you voluntarily provide</h3>
              <p className="text-gray-600 leading-relaxed mb-3">
                We may collect information you choose to submit through contact forms or email, including:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-1 ml-4">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Company name</li>
                <li>Message content</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mb-6 bg-gray-50 p-4 border-l-4 border-green">
                You should not submit confidential, sensitive, or privileged information through this website.
              </p>

              <h3 className="font-medium text-navy mb-3">Automatically collected information</h3>
              <p className="text-gray-600 leading-relaxed mb-3">
                We may collect limited technical data, including:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-1 ml-4">
                <li>IP address</li>
                <li>Browser type and device information</li>
                <li>Pages visited and time spent on the site</li>
              </ul>
              <p className="text-gray-600 leading-relaxed">
                This information is used solely for site administration and analytics.
              </p>
            </div>

            {/* Section 3 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">3. How We Use Information</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                We use collected information to:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-1 ml-4">
                <li>Respond to inquiries</li>
                <li>Communicate about potential legal services</li>
                <li>Operate and improve the website</li>
                <li>Comply with legal obligations</li>
              </ul>
              <p className="text-gray-600 leading-relaxed font-medium">
                We do not sell or rent personal information.
              </p>
            </div>

            {/* Section 4 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">4. No Attorney-Client Relationship</h2>
              <p className="text-gray-600 leading-relaxed">
                Submitting information through this website does not create an attorney-client relationship. An attorney-client relationship is formed only through a written engagement agreement signed by both parties.
              </p>
            </div>

            {/* Section 5 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">5. Confidentiality Warning</h2>
              <p className="text-gray-600 leading-relaxed bg-gray-50 p-4 border-l-4 border-navy">
                Communications through this website are not encrypted and may not be secure. Do not send confidential or time-sensitive information through the contact form or email links on this site.
              </p>
            </div>

            {/* Section 6 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">6. Cookies and Analytics</h2>
              <p className="text-gray-600 leading-relaxed">
                We may use cookies or similar technologies for basic analytics and site functionality. You may disable cookies through your browser settings.
              </p>
            </div>

            {/* Section 7 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">7. Information Sharing</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                We may share information only:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
                <li>With service providers that support website operations</li>
                <li>When required by law or legal process</li>
                <li>To protect the rights, property, or safety of the firm or others</li>
              </ul>
            </div>

            {/* Section 8 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">8. Data Security</h2>
              <p className="text-gray-600 leading-relaxed">
                We implement reasonable administrative and technical safeguards to protect information. No system is completely secure and we cannot guarantee absolute security.
              </p>
            </div>

            {/* Section 9 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">9. Third-Party Links</h2>
              <p className="text-gray-600 leading-relaxed">
                This website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites.
              </p>
            </div>

            {/* Section 10 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">10. Updates to This Policy</h2>
              <p className="text-gray-600 leading-relaxed">
                We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
              </p>
            </div>

            {/* Section 11 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl text-navy mb-4">11. Contact</h2>
              <p className="text-gray-600 leading-relaxed">
                If you have questions about this Privacy Policy, contact:{' '}
                <a href="mailto:privacy@kattorney.com" className="text-green hover:underline">
                  privacy@kattorney.com
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};
